import { useState, useEffect } from 'react';
import * as R from 'ramda';
import { getCourses, _getFunnelReport } from '../../util/api';
import CourseForm from "./form/CourseForm";
import LoadingModal from '../dumb/LoadingModal'
import NotificationDisplay  from '../dumb/NotificationDisplay';
import FunnelChart from '../dumb/graph/FunnelChart';

function FunnelReportComponent() {
    
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined);
    const [notification, setNotification] = useState(undefined);
    const [selectedCourses, setSelectedCourses] = useState([]);
    const [selectedBatches, setSelectedBatches] = useState([]);
    const [startDate, setStartDate] = useState(undefined);
    const [endDate, setEndDate] = useState(undefined);
    const [courses, setCourses] = useState([]);
    const [batches, setBatches] = useState([]);
    const [funnelReport, setFunnelReport] = useState(undefined);

    useEffect(() => {
        setLoading(true);
        getCourses()
        .then(courses =>  {
            setCourses(courses)
            setLoading(false);
        })
        .catch(error => {
            console.log(`error = ${error}`);
            setError(error);
            setLoading(false);
        })
    }, []);

    useEffect(() => {
        let batches = [];
        R.forEach(courseName => {
            let selectedCourse = R.find(course => course.courseName === courseName)(courses);
            batches.push(...selectedCourse.batches);
        })(selectedCourses);
        setBatches(batches);
    }, [courses, selectedCourses]);


    return (
        <div>
            {
                !R.isNil(notification) && (
                    <NotificationDisplay
                        notificationText={notification}
                        close={() => setNotification(undefined)}
                    />
                )
            }
            {
                !R.isNil(error) && (
                    <div style={{ color: 'red' }}> { error } </div>
                )
            }
            <CourseForm
                courses={courses}
                batches={batches}
                onSelectCourses={selectedCourses => setSelectedCourses(selectedCourses)}
                onSelectBatches={selectedBatches => setSelectedBatches(selectedBatches)}
                onSelectStartDate={startDate => setStartDate(startDate)}
                onSelectEndDate={endDate => setEndDate(endDate)}
            />
            <button
                class="btn btn-primary"
                onClick={() => {
                    setLoading(true);
                    let filterCondition = { };
                    if (selectedCourses.length > 0) { filterCondition['targetCourse'] = selectedCourses };
                    if (selectedBatches.length > 0) { filterCondition['targetBatch'] = selectedBatches };
                    if (!R.isNil(startDate)) { filterCondition['dateAddedStart'] = startDate };
                    if (!R.isNil(endDate)) { filterCondition['dataAddedEnd'] = endDate };
                    console.log(`filterCondition = ${JSON.stringify(filterCondition)}`);
                    _getFunnelReport(filterCondition)
                    .then(report => {
                        setFunnelReport(report);
                        setLoading(false);
                        setNotification('Report Generated!')
                    })
                    .catch(error => {
                        console.error(error);
                        setError(`${JSON.stringify(error)}`);
                        setLoading(false);
                    });
                }}
            >
                Get Report
            </button>
            {
                !R.isNil(funnelReport) && (
                    // <div> Hello </div>
                    <FunnelChart
                        title="Sales Funnel"
                        dataPoints={funnelReport}
                        extractX={obj => obj.stage}
                        extractY={obj => obj.count}
                    />
                )
            }
            {
                    loading && (
                        <LoadingModal />
                    )
                }
        </div>
    );
}

export default FunnelReportComponent;